export default __webpack_public_path__ + "static/media/is.b9914247.svg";